module.exports = __webpack_public_path__ + "img/cookie_option.9f998a5b.svg";